import c from 'classnames';
import React from 'react';

import { TextColor, Typography } from '@repo/ui';

import illustration from 'assets/images/summary/first-look/actionplan_categories_illustration_1.svg';
import { useProcessedActionPlanData } from '../hooks/useProcessedActionPlanData';
import { SLIDE_BACKGROUND_COLORS } from '../slideBackgroundColors';

import { AgeGroup, getAgeGroup } from '@repo/utils';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import styles from './ActionPlanCategories.module.css';
import slideStyles from './Slides.module.css';

export const ActionPlanDietary: React.FC = () => {
  const { dietary: items, dietaryTotal: totalCount } =
    useProcessedActionPlanData();
  const remainingCount = totalCount - items.length;

  const { currentKit, currentTinyAccount } = useCurrentKitAndTinyAccount();
  const isAdult =
    getAgeGroup(currentKit?.age_at_sampling ?? 0) === AgeGroup.ADULT;

  return (
    <div
      className={c(slideStyles.slideWrapper, styles.slideContainer)}
      style={{ backgroundColor: SLIDE_BACKGROUND_COLORS.actionPlanDietary }}
    >
      <div className={styles.contentContainer}>
        <Typography
          variant='heading-2xl'
          color={TextColor.GREEN}
          weight='medium'
        >
          Recommended dietary changes
        </Typography>

        {items.length > 0 ? (
          <>
            <ul className={styles.listContainer}>
              {items.map((item, index) => (
                <li key={index}>
                  <Typography variant='heading-m'>{item}</Typography>
                </li>
              ))}
            </ul>
            {remainingCount > 0 && (
              <Typography
                variant='heading-s'
                color={TextColor.GREEN}
                weight='bold'
              >
                +{remainingCount} more
              </Typography>
            )}
          </>
        ) : (
          <Typography variant='heading-m'>
            No dietary recommendations available
          </Typography>
        )}
        <Typography variant='label'>
          View {isAdult ? 'your' : `${currentTinyAccount?.first_name}'s`} Action
          Plan for more details on each step.
        </Typography>
      </div>
      <div className={c(styles.bottom, styles.background, styles.background1)}>
        <img src={illustration} alt='dietary recommendations illustration' />
      </div>
    </div>
  );
};
